const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

function action(type, data = {}) {
  return { type, ...data };
}

export const LOAD_APP = createRequestTypes('LOAD_APP');

export const loadApp = {
  request: () => action(LOAD_APP[REQUEST]),
  success: () => action(LOAD_APP[SUCCESS]),
  failure: () => action(LOAD_APP[FAILURE]),
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js